import { type App } from "vue"
import { AuthService } from "@services/auth.service"
import { AddressService } from "@services/address.service"
import { WattWatchersService } from "@services/wattwatchers.service"
import { EnedisService } from "@services/enedis.service"
// plugins/services.ts
export default {
    install: (app: App) => {
        const services = {
            addressService: new AddressService(),
            authService: new AuthService(),
            wattWatchersService: new WattWatchersService(),
            enedisService: new EnedisService(),
        }

        const provideServices: Record<string, (...args: any[]) => any> = {}

        for (const service of Object.values(services)) {
            for (const funcName of Object.getOwnPropertyNames(
                Object.getPrototypeOf(service)
            ).filter((name) => name !== "constructor")) {
                app.config.globalProperties[`$${funcName}`] = (
                    service[funcName as keyof typeof service] as (
                        ...args: any[]
                    ) => any
                ).bind(service)

                provideServices[`$${funcName}`] = (
                    service[funcName as keyof typeof service] as (
                        ...args: any[]
                    ) => any
                ).bind(service)
            }
        }

        app.provide("services", provideServices)
    },
}
